/* eslint-disable no-undef */
import axios from 'axios';
import * as types from '../constantes/project';

export const ProjectAction =
  (
    project,
    monthName,
    status,
    user,
    links,
    totalRateio,
    totalValueCnpj1,
    totalValueCnpj2,
    totalValueStatus,
    totalValue,
    year,
  ) =>
  async (dispatch, getState) => {
    dispatch({
      type: types.PROJECT_REQUEST,
      payload: {
        project,
        monthName,
        status,
        user,
        links,
        totalRateio,
        totalValueCnpj1,
        totalValueCnpj2,
        totalValueStatus,
        totalValue,
        year,
      },
    });

    try {
      const {
        userSign: { userInfo },
      } = getState();

      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/project/add`,
        {
          project,
          monthName,
          status,
          user,
          links,
          totalRateio,
          totalValueCnpj1,
          totalValueCnpj2,
          totalValueStatus,
          totalValue,
          year,
        },
        { headers: { Authorization: `bearer ${userInfo.token}` } },
      );
      dispatch({
        type: types.PROJECT_SUCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: types.PROJECT_ERROR,
        payload: error.response && error.response.data.message ? error.response.data.message : error.message,
      });
    }
  };

export const GetProjectAction = () => async (dispatch, getState) => {
  dispatch({
    type: types.GET_PROJECT_REQUEST,
  });

  try {
    const {
      userSign: { userInfo },
    } = getState();

    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/project`, {
      headers: { Authorization: `bearer ${userInfo.token}` },
    });
    dispatch({
      type: types.GET_PROJECT_SUCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.GET_PROJECT_ERROR,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const SearchProjectAction = (id) => async (dispatch, getState) => {
  dispatch({
    type: types.SEARCH_PROJECT_REQUEST,
    payload: id,
  });

  try {
    const {
      userSign: { userInfo },
    } = getState();

    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/project/${id}`, {
      headers: { Authorization: `bearer ${userInfo.token}` },
    });
    dispatch({
      type: types.SEARCH_PROJECT_SUCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.SEARCH_PROJECT_ERROR,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const UpdateProjectAction =
  (id, project, status, user, links, totalRateio, totalValueCnpj1, totalValueCnpj2, totalValueStatus, totalValue) =>
  async (dispatch, getState) => {
    dispatch({
      type: types.UPDATE_PROJECT_REQUEST,
      payload: {
        id,
        project,
        status,
        user,
        links,
        totalRateio,
        totalValueCnpj1,
        totalValueCnpj2,
        totalValueStatus,
        totalValue,
      },
    });

    try {
      const {
        userSign: { userInfo },
      } = getState();

      const { data } = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/project/${id}`,
        {
          project,
          status,
          user,
          links,
          totalRateio,
          totalValueCnpj1,
          totalValueCnpj2,
          totalValueStatus,
          totalValue,
        },
        {
          headers: { Authorization: `bearer ${userInfo.token}` },
        },
      );
      dispatch({
        type: types.UPDATE_PROJECT_SUCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: types.UPDATE_PROJECT_ERROR,
        payload: error.response && error.response.data.message ? error.response.data.message : error.message,
      });
    }
  };

export const DeleteProjectAction = (projectId) => async (dispatch, getState) => {
  dispatch({
    type: types.DELETE_PROJECT_SUCESS,
    payload: projectId,
  });

  try {
    const {
      userSign: { userInfo },
    } = getState();

    const { data } = await axios.delete(`${process.env.REACT_APP_API_URL}/api/project/${projectId}`, {
      headers: { Authorization: `bearer ${userInfo.token}` },
    });
    dispatch({
      type: types.DELETE_PROJECT_SUCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.DELETE_PROJECT_ERROR,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const SearchUserProjectAction = (id) => async (dispatch, getState) => {
  dispatch({
    type: types.SEARCH_USER_PROJECT_REQUEST,
    payload: id,
  });

  try {
    const {
      userSign: { userInfo },
    } = getState();

    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/project/historic/${id}`, {
      headers: { Authorization: `bearer ${userInfo.token}` },
    });
    dispatch({
      type: types.SEARCH_USER_PROJECT_SUCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.SEARCH_USER_PROJECT_ERROR,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const SearchProjectByMonthAction = (monthName) => async (dispatch, getState) => {
  dispatch({
    type: types.SEARCH_PROJECT_BY_MONTH_REQUEST,
    payload: monthName,
  });

  try {
    const {
      userSign: { userInfo },
    } = getState();

    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/project/months/${monthName}`, {
      headers: { Authorization: `bearer ${userInfo.token}` },
    });
    dispatch({
      type: types.SEARCH_PROJECT_BY_MONTH_SUCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.SEARCH_PROJECT_BY_MONTH_ERROR,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};
